export default "__VITE_ASSET__BcJ3h6g8__"